import { memo } from 'react';

import { TableWithExternalScroll } from 'UIPackage/MainModule/components/TableWithExternalScroll';
import { IUserOrganization } from 'APIPackage/AuthModule/interfaces/IUserOrganization';

import { OrganizationRow } from './OrganizationRow';
import styles from './OrganizationTable.module.scss';

interface IOrganizationTableProps {
  data?: IUserOrganization[];
  onEnter: (organization: IUserOrganization) => void;
}

const OrganizationTableWithoutExternalScroll = memo(({ data, onEnter }: IOrganizationTableProps) => (
  <table className={styles.OrganizationTable}>
    <thead>
      <tr>
        <th className={styles.FullNameCell}>Полное наименование</th>
        <th className={styles.OgrnCell}>ОГРН</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {data?.map(row => {
        return <OrganizationRow data={row} key={row.esiaOrgId} onEnter={onEnter} />;
      })}
    </tbody>
  </table>
));

export const OrganizationTable = TableWithExternalScroll(OrganizationTableWithoutExternalScroll);
